import React from 'react';
import StockLessDetail from 'components/Tvendo/Article/Operations/StockLess/Detail';

export default function () {
  return <StockLessDetail />;
}
